import {openDialog} from 'platform/components';

import {ComponentProps} from 'react';

import i18n from '@dms/i18n';

import {TEST_DRIVE_DIALOG_ID} from '../../../constants/TEST_DRIVE_DIALOG_ID';
import {TestDriveDialog} from '../TestDriveDialog';

export const openCreateTestDriveDialog = (props: ComponentProps<typeof TestDriveDialog>) =>
  openDialog(<TestDriveDialog {...props} />, {
    id: TEST_DRIVE_DIALOG_ID,
    title: i18n.t('entity.testDrive.labels.createTestDrive'),
    size: 'large',
    withAdditionalFooter: true,
  });
